import * as React from "react";
const SvgArrowDownward = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 -960 960 960", width: "1em", fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M440-800v487L216-537l-56 57 320 320 320-320-56-57-224 224v-487h-80Z" }));
export default SvgArrowDownward;
